"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var getCellColor_1 = require("./colorScale/getCellColor");
var Heatmap_Enums_1 = require("./Heatmap_Enums");
var isTotalsRow = function (cell) {
    return cell.yAxisKey === Heatmap_Enums_1.Rows.Totals;
};
var isParentRow = function (cell) {
    return cell.yAxisKey === Heatmap_Enums_1.Rows.Parent;
};
var isTotalsCellClass = function (cell) {
    var className = "";
    if (isTotalsRow(cell))
        className = "heatmap__cell--totals";
    return className;
};
var isClickableCell = function (cell) {
    return ((cell === null || cell === void 0 ? void 0 : cell.value) > 0
        &&
            ((cell === null || cell === void 0 ? void 0 : cell.yAxisKey) != Heatmap_Enums_1.Rows.Totals
                ||
                    (cell === null || cell === void 0 ? void 0 : cell.yAxisKey) === Heatmap_Enums_1.Rows.Parent));
};
var isClickableCellClass = function (cell) {
    var className = "";
    if (isClickableCell(cell))
        className = "heatmap__cell--clickable";
    return className;
};
var cellClassName = function (cell) {
    return ("heatmap__cell  \n    ".concat(isTotalsCellClass(cell), "\n    ").concat(isClickableCellClass(cell)));
};
var cellValue = function (cell) {
    if (!cell)
        return "0";
    return cell.value;
};
var labelClass = function (cell, model) {
    var hideLabel = "";
    if (!model.showValues && !isTotalsRow(cell))
        hideLabel = "heatmap__cell--hide";
    return hideLabel;
};
var onCellClick = function (cell, model) {
    if (!isClickableCell(cell))
        return;
    var index = +cell.xAxisKey;
    model.onCellClick(cell.rowId, model.getCellMonth(index), model.getCellYear(index), cellValue(cell));
};
//#endregion
var Cell = (0, mobx_react_1.observer)(function (_a) {
    var cell = _a.cell, model = _a.model;
    var cellColors = (0, getCellColor_1.getCellColor)(cell, model);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: cellClassName(cell), style: {
            backgroundColor: cellColors.backgroundColor,
            color: cellColors.color
        }, onClick: function () { return onCellClick(cell, model); } }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "m-0 ".concat(labelClass(cell, model)) }, { children: cellValue(cell) })) })));
});
exports.Cell = Cell;
